import { Start } from 'base/src/main.tsx'
import { sideBarOptions } from './infra/routes/sideBarOptions.ts'
import { LangList } from 'base/i18n.ts'

import translationEN from "./lang/en/translation.json";
import translationPT from "./lang/pt/translation.json";
import { AuthRouter } from './infra/routes/authRoutes.tsx';
import { AuthReducerList } from './store/authReducer.ts';
import { SistemaList } from 'domain/types/sistema/sistemaList.ts';

const langList: LangList = {
    en: translationEN,
    pt: translationPT
}

Start(
    {
        storeRoot: AuthReducerList,
        routes: AuthRouter,
        langList: langList,
        titulo: "Gruppy",
        sidebarOptions: sideBarOptions,
        sistemaID: SistemaList.auth
    })
// Start({storeRoot: PanelsReducer, startComponent: <Panels/>} as StartProps)
